import { DefaultWeightSource } from "@redotech/admin-sdk/rpc/schema/returns/get-team-default-weight";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { SkeletonText } from "@redotech/redo-web/skeleton";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { RedoAdminRpcClientContext } from "../../../../app/redo-admin-rpc-client-provider";
import { TeamContext } from "../../../team";

const sourceLabels: Record<DefaultWeightSource, string> = {
  settings: "Team settings",
  onboarding: "Onboarding average",
  fallback: "System default",
};

export const DefaultWeightDisplay = memo(function DefaultWeightDisplay() {
  const team = useRequiredContext(TeamContext);
  const client = useRequiredContext(RedoAdminRpcClientContext);

  const defaultWeightLoad = useLoad(
    async (signal) => {
      return client.getTeamDefaultWeight({ teamId: team._id }, { signal });
    },
    [client, team._id],
  );

  if (defaultWeightLoad.pending) {
    return (
      <Card title="Default package weight">
        <Flex dir="column" gap="md">
          <SkeletonText length={20} />
        </Flex>
      </Card>
    );
  }

  if (defaultWeightLoad.error || !defaultWeightLoad.value) {
    return null;
  }

  const { weightOunces, source } = defaultWeightLoad.value;

  return (
    <Card title="Default package weight">
      <Flex dir="column" gap="md">
        <Text fontSize="xs" textColor="secondary">
          This weight is used when products don't have weight information. It
          cannot be edited here.
        </Text>
        <Flex dir="row" gap="xl">
          <Flex dir="column" gap="xs" style={{ flex: 1 }}>
            <RedoTextInput
              label="Weight (oz)"
              setValue={() => {}}
              size="sm"
              state="readonly"
              value={weightOunces.toFixed(2)}
            />
          </Flex>
          <Flex dir="column" gap="xs" style={{ flex: 1 }}>
            <RedoTextInput
              label="Source"
              setValue={() => {}}
              size="sm"
              state="readonly"
              value={sourceLabels[source as DefaultWeightSource]}
            />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
});
